module.exports = __webpack_public_path__ + "static/media/prizm-snow.b9ab54b4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/prizm-snow.mp4
// module id = 3541
// module chunks = 0